import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-grey-rectangle',
  templateUrl: './grey-rectangle.component.html',
  styleUrls: ['./grey-rectangle.component.scss']
})
export class GreyRectangleComponent {

  @Input() width: string = '';
  @Input() height: string = '';


  applyDesign() {

    let widthNumber = this.width.split('px')[0];
    return { 'min-height': this.height, width: (Number(widthNumber) - 20) + 'px', 'margin': '15px 0px' };
  }

}
